export const environment = {
    apiHost: "",
    enableLog: true,
    auth: {
        bypass: false,
        region: "eu-north-1",
        userPoolId: "eu-north-1_m0ig9BS3z",
        userPoolClientId: "2ufra5gfai5nn1976cce9cnp3s",
    },
    support: {
        email: "support@galcollege.org.il",
    },
};
